import { IntlShape } from "react-intl";

import { fromISOValue, listToString } from "@nens/shared-utils";

export function fromISODurationToString(intl: IntlShape, isoDuration: string) {
  const durationObject = fromISOValue(isoDuration);
  const { years, months, days, hours, minutes, seconds } = durationObject;
  const parts = [];

  if (years) {
    parts.push(
      intl.formatMessage(
        { id: "duration.years", defaultMessage: "{count, plural, one {# year} other {# years} } " },
        { count: years }
      )
    );
  }

  if (months) {
    parts.push(
      intl.formatMessage(
        {
          id: "duration.months",
          defaultMessage: "{count, plural, one {# month} other {# months}}",
        },
        { count: months }
      )
    );
  }

  if (days) {
    parts.push(
      intl.formatMessage(
        { id: "duration.days", defaultMessage: "{count, plural, one {# day} other {# days}}" },
        { count: days }
      )
    );
  }

  if (hours) {
    parts.push(
      intl.formatMessage(
        { id: "duration.hours", defaultMessage: "{count, plural, one {# hour} other {# hours}}" },
        { count: hours }
      )
    );
  }

  if (minutes) {
    parts.push(
      intl.formatMessage(
        {
          id: "duration.minutes",
          defaultMessage: "{count, plural, one {# minute} other {# minutes}}",
        },
        { count: minutes }
      )
    );
  }

  if (seconds) {
    parts.push(
      intl.formatMessage(
        {
          id: "duration.seconds",
          defaultMessage: "{count, plural, one {# second} other {# seconds}}",
        },
        { count: seconds }
      )
    );
  }

  return listToString(parts);
}
